import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import { sync } from "vuex-router-sync";
import Argon from "./plugins/argon-kit";
import VueScrollTo from "vue-scrollto";
import utils from "./mixins/utils.js";
import VueParallaxJs from 'vue-parallax-js'
import VueCookie from 'vue-cookie'
sync(store, router);
//import VueAgile from 'vue-agile'
//import './registerServiceWorker.js'
import VueAnalytics from 'vue-analytics';
import VueCarousel from 'vue-carousel';
Vue.use(VueCarousel);
// Vue.use(VueAgile)
Vue.config.productionTip = false;
Vue.use(Argon);
Vue.use(VueScrollTo);
Vue.mixin(utils);
Vue.use(VueParallaxJs)
Vue.use(VueCookie);
Vue.use(VueAnalytics, {
  id: 'UA-171150248-2',
  router,
  ready () {
    Vue.$ga.set('dimension1', 'online')
  }
})

// import VueFacebookPixel from 'vue-facebook-pixel'
 
// Vue.use(VueFacebookPixel)

// Vue.analytics.fbq.init('478584920085422', {
//   em: 'marketing.notin@gmail.com'
// })

// Vue.analytics.fbq.event('ViewContent', {
//   content_name: 'Página Web Corporativa NOTIN'
// })

// Vue.use(VueScrollTo, {
//   container: "body",
//   duration: 500,
//   easing: "ease",
//   offset: 0,
//   force: true,
//   cancelable: true,
//   onStart: false,
//   onDone: false,
//   onCancel: false,
//   x: false,
//   y: true
// })
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
